import config from '@/config'
import request from '@/helpers/request'
import { legalLinks } from '@/helpers/userData.js'

export default {
	namespaced: true,

	state: {
		language: null,
		customLanding: {
			lpid: {
				age_selection: {},
				age_selection_mature: {},
				female_funnel: {},
				main_loader: {},
				male_funnel: {},
			},
		},
	},

	mutations: {
		setLanguage(state, language) {
			state.language = language
		},
		setCustomLanding(state, customLanding) {
			state.customLanding = customLanding
		},
	},

	getters: {
		getLanguage(state) {
			return state.language
		},
		getCustomLanding(state) {
			return state.customLanding
		},
		getLegalLinks(state) {
			return legalLinks(state.language)
		},
	},

	actions: {
		async loadCustomLandingData(store) {
			const localizationHost = `${config('ApiLocalization')}${store.getters['getLanguage']}`
			const customLandingData = await request(`${localizationHost}/custom-landing.json`)

			store.commit('setCustomLanding', customLandingData)
		},
	},
}
